import { bem } from '@core-utils/bem';

import styles from './SignInBox.module.scss';

export const signInBoxStyles = {
    blockScope: styles.SignInBox,
    header: styles[bem('SignInBox', 'header')],
    supportLinks: styles[bem('SignInBox', 'supportLinks')],
    actionButtons: styles[bem('SignInBox', 'actionButtons')],
};
